(() => {
  angular.module('pims').filter('fullname', () => {
    return user => {
      if (!_.isObject(user)) {
        return user;
      }

      if (user.name) {
        return user.name;
      } else {
        return `${user.firstname} ${user.lastname}`;
      }
    };
  });
})();